import React from "react";
import { format } from "date-fns";
import { getDoctorNameFlexible, getPatientDisplayName } from "@/utils/dataLookups";

/**
 * Renders appointment content based on duration and view type
 * For appointments <= 15 minutes: shows only patient name
 * For appointments > 15 minutes: shows time + patient name + doctor (if overlapping)
 */
const AppointmentContent = ({
  appointment,
  viewType,
  columnInfo,
  allDoctors,
  endTimeString,
}) => {
  // Calculate actual duration from start and end time
  let duration = appointment.duration_actual || 60;

  if (appointment.end_time) {
    const startTime = new Date(appointment.appointment_date);
    const [endHour, endMinute] = appointment.end_time.split(":").map(Number);
    const endTime = new Date(startTime);
    endTime.setHours(endHour, endMinute);
    duration = (endTime - startTime) / 60000; // Convert ms to minutes
  }

  const formatTime = (dateTimeString) => {
    try {
      return format(new Date(dateTimeString), "h:mm a");
    } catch (error) {
      return "Invalid time";
    }
  };

  // Short appointment: only show patient name
  if (duration <= 15) {
    return (
      <div className={`${viewType === "day" ? "text-sm" : "text-xs"} font-medium text-slate-900 truncate`}>
        {getPatientDisplayName(appointment)}
      </div>
    );
  }

  // Long appointment: show full details - Teams/Outlook style
  if (viewType === "day") {
    return (
      <div className="space-y-0.5">
        <div className="text-xs text-slate-600">
          {formatTime(appointment.appointment_date)} - {endTimeString}
        </div>
        <div className="text-sm font-medium text-slate-900 truncate">
          {getPatientDisplayName(appointment)}
        </div>
        {columnInfo && columnInfo.groupSize > 1 && (
          <div className="text-xs text-slate-500 truncate">
            {getDoctorNameFlexible(appointment.doctor_id, allDoctors)}
          </div>
        )}
      </div>
    );
  }

  // Week view with long appointment - Teams/Outlook style
  return (
    <div className="text-xs space-y-0.5">
      <div className="text-slate-600 truncate">
        {formatTime(appointment.appointment_date)}
      </div>
      <div className="font-medium text-slate-900 truncate">
        {getPatientDisplayName(appointment)}
      </div>
      {columnInfo && columnInfo.groupSize > 1 && (
        <div className="text-slate-500 truncate" style={{ fontSize: "10px" }}>
          {getDoctorNameFlexible(appointment.doctor_id, allDoctors)}
        </div>
      )}
    </div>
  );
};

export default AppointmentContent;
